// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--bbbb4";
export var checkboxGroup = "Checkbox-module--checkboxGroup--2d1f1";
export var checkboxInput = "Checkbox-module--checkboxInput--494df";
export var checkboxLabel = "Checkbox-module--checkboxLabel--4bce0";
export var label__hidden = "Checkbox-module--label__hidden--3beea";
export var lgBreak = "1200";
export var mdBreak = "992";
export var size__md = "Checkbox-module--size__md--0ca13";
export var size__sm = "Checkbox-module--size__sm--dcfc1";
export var smBreak = "768";
export var theme__purple = "Checkbox-module--theme__purple--548a4";
export var theme__teal = "Checkbox-module--theme__teal--9ee1f";
export var xsBreak = "480";